var ExtraSidebar = /** @class */ (function () {
    function ExtraSidebar(sidebarService, route, router, bookingService, mybService) {
        this.sidebarService = sidebarService;
        this.route = route;
        this.router = router;
        this.bookingService = bookingService;
        this.mybService = mybService;
    }
    Object.defineProperty(ExtraSidebar.prototype, "flight", {
        // ACCESSORS
        get: function () { return this._flight; },
        set: function (value) { this._flight = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExtraSidebar.prototype, "same", {
        get: function () { return this._same; },
        set: function (value) { this._same = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExtraSidebar.prototype, "passengers", {
        get: function () { return this._passengers; },
        set: function (value) { this._passengers = value; },
        enumerable: true,
        configurable: true
    });
    // SIDEBAR INTERACTIONS
    /** Close sidebar and clear secondary route */
    ExtraSidebar.prototype.closeSidebar = function () {
        this.sidebarService.closeSidebar();
        this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
    };
    /** Handles close action intention **/
    ExtraSidebar.prototype.TAP_handleClose = function () { this.closeSidebar(); };
    ExtraSidebar.prototype.TAP_handleDone = function () { this.showLoadingCloseSidebar(); };
    /** Show loading and close sidebar */
    ExtraSidebar.prototype.showLoadingCloseSidebar = function () {
        this.sidebarService.showLoadingAndCloseSidebar();
    };
    // OTHER REUSABLE METHODS
    /**
     * @param passenger {Object} Passenger
     * @returns Seat assigned to @passenger
     */
    ExtraSidebar.prototype.TAP_passengerSeat = function (passenger) {
        return passenger.seat;
    };
    /**
     * @param passenger {Object} Passenger
     * @return total bags assigned to @passenger
     */
    ExtraSidebar.prototype.TAP_passengerBags = function (passenger) {
        return passenger.luggage;
    };
    /** Returns a string that briefly describes the flight route */
    ExtraSidebar.prototype.TAP_printRoute = function () {
        if (this.flight) {
            var departure = this.flight.departure.airport.location.city, arrival = this.flight.arrival.airport.location.city;
            return departure + " \u2014 " + arrival;
        }
        else {
            return '';
        }
    };
    /**
     * @param passenger {Object} Passenger
     * Returns a string with passenger's name
     */
    ExtraSidebar.prototype.TAP_printPassengerName = function (passenger) {
        return !passenger.passenger.name ? passenger.passenger.type + ' ' + passenger.passenger.typeCount : passenger.passenger.name;
    };
    /**
     * @param passenger {Object} Passenger
     * Returns a string with passenger's name
     */
    ExtraSidebar.prototype.TAP_printInitialsPassengerName = function (passenger) {
        return passenger.passenger.name ? passenger.passenger.firstName.charAt(0).toUpperCase() + passenger.passenger.lastName.charAt(0).toUpperCase() : "" + passenger.passenger.type.charAt(0).toUpperCase() + passenger.passenger.typeCount;
    };
    return ExtraSidebar;
}());
export { ExtraSidebar };
